export const formatTonsFromKg = (quantity?: number | null): string => {
  if (quantity === null || quantity === undefined) return '-';
  return `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3 }).format(quantity / 1000)} t`;
};

export const formatKgFromG = (quantity: number | null): string => {
  if (quantity === null) return '-';
  return formatKg(quantity / 1000);
};

const formatWeight = (quantity: number | null, expectedDecimals: number = 3, unit: string) => {
  if (quantity === null) return '-';
  return `${new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: expectedDecimals,
    minimumFractionDigits: expectedDecimals,
  }).format(quantity)} ${unit}`;
};

export const formatKg = (quantity: number | null, expectedDecimals: number = 3): string => {
  return formatWeight(quantity, expectedDecimals, 'kg');
};

export const formatTons = (quantity: number | null, expectedDecimals: number = 3): string => {
  return formatWeight(quantity, expectedDecimals, 't');
};

export const floatWeightToInt = (weight: number) => {
  return Math.round(weight * 1000);
};
